import React from "react";
import { RouterProvider } from "react-router-dom";
import Footer from "../common-component/Footer";
import Header from "../common-component/Header";
import NewHeader from "../common-component/NewHeader";
import router from "../Router";

const App: React.FC = () => {
  const currentPath = window.location.pathname;
  const isAuthPage = ["/vendor/login", "/vendor/signup"].includes(currentPath);
  const isHomePage = currentPath === "/";

  return (
    <>
      {!isAuthPage && (isHomePage ? <Header /> : <NewHeader />)}
      <RouterProvider router={router} />
      {!isAuthPage && <Footer />}
    </>
  );
};

export default App;
